export default {
  apiServerUrl: 'https://szwalnia.the-dev.org/',
  useConfig: 'dev',
  additionalConfig: {
    'prod': {
      hplUrl: 'https://headwear.thecamels.pl/'
    },
    'dev': {
      hplUrl: 'https://headwear2.the-dev.org/'
    }
  }
};
